module.exports = __webpack_public_path__ + "assets/images/project/menu/china-thumb.jpg?v=b0533863";